import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useSiteSettings } from './context/SiteSettingsProvider/SiteSettingsProvider';

// Homepages
import DataDriven from './pages/home-pages/data-driven';

// inner pages
import Contact from './pages/inner-pages/contact';
import Realisations from './pages/inner-pages/realisations';
import Expertises from './pages/inner-pages/expertises';
import ExpertiseDetail from './pages/inner-pages/expertise-detail';
import Partenaires from './pages/inner-pages/partenaires';
import QuiSommesNous from './pages/inner-pages/qui-sommes-nous';
import NotreHistoire from './pages/inner-pages/notre-histoire';
import PourquoiNousChoisir from './pages/inner-pages/pourquoi-nous-choisir';
import DigitalTwinPage from './pages/inner-pages/solution-page/DigitalTwinPage';
import BlockchainPage from './pages/inner-pages/solution-page/BlockchainPage';
import ELivingLabPage from './pages/inner-pages/solution-page/ELivingLabPage';

// miscellaneous pages
import NotFound from './pages/404';
import Login from './pages/auth/login';
import Signup from './pages/auth/sign-up';
import ResetPassword from './pages/auth/reset-password';
import ForgotPassword from './pages/auth/forgot-password';
import NioScrollToTop from './components/NioScrollToTop/NioScrollToTop';

import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminDomainsPage from './pages/admin/AdminDomainsPage';
import AdminProjectsPage from './pages/admin/AdminProjectsPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';

function PortfolioRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/realisations${search}`} replace />;
}

function AppRoutes() {

  return (
    <Routes>

      {/* Default: home at / */}
      <Route path="/" element={<DataDriven />} />
      <Route path="/index-data-driven" element={<Navigate to="/" replace />} />

      {/* inner pages */}
      <Route path='/contact-us' element={<Contact />} />
      <Route path="/realisations" element={<Realisations />} />
      <Route path="/portfolio" element={<PortfolioRedirect />} />
      <Route path="/expertises" element={<Expertises />} />
      <Route path="/expertises/:slug" element={<ExpertiseDetail />} />
      <Route path="/digital-twin" element={<DigitalTwinPage />} />
      <Route path="/blockchain" element={<BlockchainPage />} />
      <Route path="/e-living-lab" element={<ELivingLabPage />} />
      <Route path="/partenaires" element={<Partenaires />} />
      <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
      <Route path="/notre-histoire" element={<NotreHistoire />} />
      <Route path="/pourquoi-nous-choisir" element={<PourquoiNousChoisir />} />
      <Route path="/nous-rejoindre" element={<Navigate to="/pourquoi-nous-choisir" replace />} />

      {/* auth */}
      <Route path='/auth/login' element={<Login />} />
      <Route path='/auth/sign-up' element={<Signup />} />
      <Route path='/auth/reset-password' element={<ResetPassword />} />
      <Route path='/auth/forgot-password' element={<ForgotPassword />} />

      {/* JASSP admin panel */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="projects" element={<AdminProjectsPage />} />
        <Route path="domains" element={<AdminDomainsPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
      </Route>

      {/* miscellaneous pages */}
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}


function App() {
  const { settings } = useSiteSettings();

  useEffect(() => {
    document.body.classList.add('nk-body');
  }, []);

  useEffect(() => {
    const faviconUrl = settings.siteFaviconUrl || '/images/favicon.ico';
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }, [settings.siteFaviconUrl]);

  return (
    <BrowserRouter>
      <NioScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}



export default App;
